import cc from "classcat"
import React from "react"

import styles from "./IntegrationSyncIcon.module.css"

import { SyncIcon } from "~/common/react-icons"

export const IntegrationSyncIcon = ({
  animated = false,
  ...props
}: {
  animated?: boolean
} & React.SVGProps<SVGSVGElement>) => (
  <SyncIcon
    className={cc({
      [styles.animated]: animated,
    })}
    {...props}
  />
)
